import {
  Bold,
  CodeInline,
  Color,
  EditorLink,
  HardBreak,
  InlineEditorBulletList,
  InlineEditorListItem,
  InlineEditorOrderedList,
  InlineEditorParagraph,
  Italic,
  LinkMarkMenubar,
  Strikethrough,
  Underline,
} from '@lyearn/lygo-blocks';

export const instructionsEditorExtensions = [
  Bold,
  Italic,
  Underline,
  Strikethrough,
  EditorLink,
  LinkMarkMenubar,
  CodeInline,
  InlineEditorBulletList,
  InlineEditorOrderedList,
  InlineEditorParagraph,
  InlineEditorListItem,
  HardBreak,
  Color,
];

export {
  Bold,
  CodeInline,
  Color,
  EditorLink,
  HardBreak,
  InlineEditorBulletList,
  InlineEditorListItem,
  InlineEditorOrderedList,
  InlineEditorParagraph,
  Italic,
  LinkMarkMenubar,
  Strikethrough,
  Underline,
};
